import Vue from 'vue'
import RecallService from "./RecallService";

class Services {
  install(Vue) {
    Vue.prototype.$recallService = new RecallService()
  }
}

Vue.use(new Services());

export default Services;